/* eslint-disable */
var $ = window.jQuery = require('jquery');

import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'categoryCourses',
  components: {
    draggable
  },
  data() {
    return {
      coursesList: [],
      categoryData: null,
      categoryId: ''
    }
  },
  computed: {
    ...mapGetters([
      'getCourseListState',
      'getcategoryDetailsByIdDataState'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    getCourseListMethod() {
      this.categoryData = this.$store.getters.getCourseListState;
      return;
    },
  },
  mounted() {
    this.categoryId = this.$route.params.categoryId;
    this.getCourseListMethod;
  },
  watch: {
    getCourseListMethod() {
      return this.$store.getters.getCourseListState;
    }
  },
  methods: {
    courseSort: function (event) {
      if (event.moved && event.moved != undefined) {
        this.updateRowIndex(this.categoryId, event.moved.element.id, Number(event.moved.newIndex) + 1);
      }
    },
    updateRowIndex(categoryId, courseId, rowIndex) {
      let data = {
        index: rowIndex
      }
      this.$store.dispatch('UpdateCourseIndex', {
        data: {
          data: data,
          categoryId: categoryId,
          courseId: courseId
        }
      })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCourseListAgain();
        })
        .catch((err) => { })
    },
    updatehandleImageUpload(event) {
      this.updateImage = event.target.files[0];
      this.updateImages = this.$refs.image.files[0];
      let formData = new FormData();
      if (this.updateImages) {
        formData.append('image', this.updateImages);
      }
      this.$store.dispatch('updateCategoryListById', {
        data: {
          formdata: formData,
          id: this.categoryUpdateformId
        }
      })
        .then((res) => {
          if (res.status == '200') {
            this.selectImage = res.data.data.image
            console.log(res.data.data.image)
            this.getCourseListAgain();
          }
        })
        .catch((err) => { })
      return
    },
    updatehandleBgImageUpload(event) {
      this.updateBgImage = event.target.files[0];
      this.updateBgImages = this.$refs.bg_image.files[0];
      let formData = new FormData();
      if (this.updateBgImages) {
        formData.append('bg_image', this.updateBgImages);
      }
      this.$store.dispatch('updateCategoryListById', {
        data: {
          formdata: formData,
          id: this.categoryUpdateformId
        }
      })
        .then((res) => {
          if (res.status == '200') {
            this.selectBgImage = res.data.data.bg_image
            console.log(res.data.data.image)
            this.getCourseListAgain();
          }
        })
        .catch((err) => { })
      return
    },
    validateUpdateCategoryBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.uploadingLoader = true
          let formData = new FormData();
          formData.append('name', this.name);
          formData.append('name_html', this.editorData);
          formData.append('description', this.description);
          if (this.updateImages) {
            formData.append('image', this.updateImages);
          }
          if (this.updateBgImages) {
            formData.append('bg_image', this.updateBgImages);
          }
          this.$store.dispatch('updateCategoryListById', {
            data: {
              formdata: formData,
              id: this.categoryUpdateformId
            }
          })
            .then((res) => {
              console.log(res.status)
              if (res.status == '200') {
                this.uploadingLoader = false
                this.categoryUpdateform = false
                this.getCourseListAgain();
                toast.success(res.data.msg);
              }
            })
            .catch((err) => { })
          return
        }
      });
    },
    previewImgFun() {
      this.previewImgModal = true
    },
    previewBgImgFun() {
      this.previewBgImgModal = true
    },
  }
}